<template>
<div class="chapter">
<div class="inner_page">
<p class="center" id="dedication">TO REUEL</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 3-dedication.vue?5c8f6f10